module.exports = __webpack_public_path__ + "static/media/Sinking.4cbbaabd.jpg";